import Dialog from 'components/base/Dialog';
import UI from 'stores/ui';
import API from 'utils/API';
import { ESOP_OPEN_ACCOUNT_REDIRECT } from 'utils/constants';

export function handleBackEsop(title: string, error: string) {
    return Dialog.alert({
        title: <h3 className="text-center">{title}</h3>,
        btnOk: __('Return to the ESOP'),
        content: <p className="text-center">{error}</p>,
        hideCloseBtn: true
    }).then(() => {
        window.location.href =
            sessionStorage.getItem(ESOP_OPEN_ACCOUNT_REDIRECT) || (UI.isMobile ? API.ESOP.m() : API.ESOP.web());
    });
}
